import { useEffect, useState } from "react";
import { useChat } from "../../../contexts/ChatProvider";

export default function CheckboxGroup({options,answers, onSendMessage, theme, handleCheckboxVisibility, isRequired}) {
  const { setIsInputDisabled } = useChat();
  const [selected, setSelected] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isQuestionSkipped, setIsQuestionSkipped] = useState(false);

  const handleChange = (option) => {
    setSelected((prev) =>
      prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, option]
    );
  };
  const removeChip = (option) => {
    setSelected((prev) => prev.filter((item) => item !== option));
  };
  useEffect(()=>{
    handleCheckboxVisibility(selected.length > 0);
  }, [selected])

  return (
    <div style={{ height: "auto", marginLeft: "12px", marginBottom: "10px", fontSize: "12px", width: "90%" }}>
      {options.map((option) => (
        <div key={option}>
          <input
            disabled={answers || isSubmitted || isQuestionSkipped}
            type="checkbox"
            value={option}
            checked={selected.includes(option) || answers?.includes(option)}
            onChange={() => handleChange(option)}
            
          />
          <label key={option} style={{ position: "relative",left: 3, bottom: 3, zIndex: "99" }}>
            {option}
          </label>
        </div>

      ))}
      <div style={{width: "100%" }}>
        {selected.length > 0 && !isSubmitted &&(
          <div style={{width: "100%", backgroundColor: "white",position:"relative", zIndex: 99, padding: "5px", borderRadius: 5}}>
            <p style={{fontWeight: "bold", fontSize: 10}}>Selected {selected.length}:</p>
            {selected.map((option)=> {
              return (
                <div
                  key={option}
                  className="rounded-full"
                  style={{
                    display: "inline-flex",
                    justifyItems: "center",
                    gap: 2,
                    backgroundColor: theme,
                    width: "auto",
                    color: "white",
                    padding: "1px 3px",
                    fontSize: "10px",
                    margin: "2px 2px"
                  }}
                >
                  <span>{option}</span>
                  <button
                    disabled={isSubmitted}
                    onClick={() => removeChip(option)}
                    className="text-white hover:text-black hover:bg-white font-bold rounded-full"
                    style={{textAlign: "center", backgroundColor: "theme", opacity: 0.5,height: 12, width: 10, margin: "auto", display: "block", margin: "0 1px",}}
                  >
                    ×
                  </button>
                </div>
              )
            })}
          </div>
        )}
        {selected.length > 0 && !isSubmitted &&(
          <div style={{paddingRight: "5px", position: "relative", width: "100%", height: 40}}>
            <button
              color={theme}
              disabled={isSubmitted}
              style={{
                border: "1px solid ",
                borderRadius: "10%",
                position: "absolute",
                right: 0,
                bottom: 0,
                padding: "0 5px",
                color: "white",
                backgroundColor: theme,
                height: 22,
                fontSize: 12
              }}
              onClick={()=> {onSendMessage(selected.join(", ")); setIsSubmitted(true); setIsInputDisabled(false);}}
            > 
              continue 
            </button>
          </div>
        )}
        {!isRequired && !(isQuestionSkipped || isSubmitted || answers) &&
          <div style={{paddingRight: "5px", position: "relative", width: "100%", height: 40, marginBottom: 10}}> 
            <button
              color={theme}
              //disabled={isSubmitted}
              style={{
                border: "1px solid ",
                borderRadius: "10%",
                position: "absolute",
                right: 10,
                bottom: 2,
                padding: "0 5px",
                color: "white",
                backgroundColor: theme,
                height: 22,
                fontSize: 12
              }}
              onClick={()=> {
                onSendMessage("skip"); 
                setIsQuestionSkipped(true); 
                setIsInputDisabled(false);
                setSelected([]);
              }}
            > 
              Skip
            </button>
          </div>}
      </div>
    </div>
  );
}